import { render, staticRenderFns } from "./TokenForm.vue?vue&type=template&id=18217e06&"
import script from "./TokenForm.vue?vue&type=script&lang=js&"
export * from "./TokenForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports